module.exports = __webpack_public_path__ + "static/background-d91d8ecbb9e26283c417043a308b9db9.png";